const initialState = null

export default function permissions(state = initialState) {
  return state
}
